import { TABLE_EVENT_TYPE } from "../../core/TABLE_EVENT_TYPE";

import { extend } from "../../tools/helper";

export const PIVOT_TABLE_EVENT_TYPE = extend(TABLE_EVENT_TYPE, {
    PIVOT_SORT_CLICK: "pivot_sort_click",
    DRILLMENU_CLICK: "drillmenu_click"
});

export const PIVOT_CHART_EVENT_TYPE = extend(TABLE_EVENT_TYPE, {
    VCHART_EVENT_TYPE: "vchart_event_type"
});
//# sourceMappingURL=PIVOT_TABLE_EVENT_TYPE.js.map
